/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  GetIntermediazioniBeneficiariParams,
  GetIntermediazioniIntermediariParams,
  GetIntermediazioniParams,
  IntermediarioDTO,
  IntermediarioRequest,
  IntermediazioneDTO,
  IntermediazioneRequest,
  WsProblema,
  WsRispostaPaginataListIntermediarioDTO,
  WsRispostaPaginataListIntermediazioneDTO,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce l'intermediazione associata all'id
 * @summary Dettaglio Intermediazione
 */
export const getIntermediazioniId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<IntermediazioneDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni/${id}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetIntermediazioniIdQueryKey = (id: string) =>
  [`/framework-cfg-domande/intermediazioni/${id}`] as const;

export const getGetIntermediazioniIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntermediazioniId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getIntermediazioniId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntermediazioniIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntermediazioniId>>
  > = ({ signal }) => getIntermediazioniId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetIntermediazioniIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntermediazioniId>>
>;
export type GetIntermediazioniIdQueryError = ErrorType<WsProblema>;

/**
 * @summary Dettaglio Intermediazione
 */
export const useGetIntermediazioniId = <
  TData = Awaited<ReturnType<typeof getIntermediazioniId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIntermediazioniIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna una intermediazione
 * @summary Modifica Intermediazione
 */
export const putIntermediazioniId = (
  id: string,
  intermediazioneRequest: IntermediazioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<IntermediazioneDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: intermediazioneRequest,
    },
    options,
  );
};

export const getPutIntermediazioniIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntermediazioniId>>,
    TError,
    { id: string; data: IntermediazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntermediazioniId>>,
  TError,
  { id: string; data: IntermediazioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntermediazioniId>>,
    { id: string; data: IntermediazioneRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putIntermediazioniId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntermediazioniIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntermediazioniId>>
>;
export type PutIntermediazioniIdMutationBody = IntermediazioneRequest;
export type PutIntermediazioniIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Modifica Intermediazione
 */
export const usePutIntermediazioniId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntermediazioniId>>,
    TError,
    { id: string; data: IntermediazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutIntermediazioniIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Consente la cancellazione di una intermediazione
 * @summary Elimina Intermediazione
 */
export const deleteIntermediazioniId = (
  id: string[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cfg-domande/intermediazioni/${id}`, method: 'delete' },
    options,
  );
};

export const getDeleteIntermediazioniIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntermediazioniId>>,
    TError,
    { id: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIntermediazioniId>>,
  TError,
  { id: string[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIntermediazioniId>>,
    { id: string[] }
  > = props => {
    const { id } = props ?? {};

    return deleteIntermediazioniId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIntermediazioniIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntermediazioniId>>
>;

export type DeleteIntermediazioniIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Elimina Intermediazione
 */
export const useDeleteIntermediazioniId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntermediazioniId>>,
    TError,
    { id: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteIntermediazioniIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Restituisce l'intermediario associata all'id
 * @summary Dettaglio Intermediario
 */
export const getIntermediazioniIntermediariId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<IntermediarioDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni/intermediari/${id}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetIntermediazioniIntermediariIdQueryKey = (id: string) =>
  [`/framework-cfg-domande/intermediazioni/intermediari/${id}`] as const;

export const getGetIntermediazioniIntermediariIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntermediazioniIntermediariIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>
  > = ({ signal }) =>
    getIntermediazioniIntermediariId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetIntermediazioniIntermediariIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>
>;
export type GetIntermediazioniIntermediariIdQueryError = ErrorType<WsProblema>;

/**
 * @summary Dettaglio Intermediario
 */
export const useGetIntermediazioniIntermediariId = <
  TData = Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniIntermediariId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIntermediazioniIntermediariIdQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna un intermediario
 * @summary Modifica Intermediario
 */
export const putIntermediazioniIntermediariId = (
  id: string,
  intermediarioRequest: IntermediarioRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<IntermediarioDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni/intermediari/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: intermediarioRequest,
    },
    options,
  );
};

export const getPutIntermediazioniIntermediariIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntermediazioniIntermediariId>>,
    TError,
    { id: string; data: IntermediarioRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putIntermediazioniIntermediariId>>,
  TError,
  { id: string; data: IntermediarioRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putIntermediazioniIntermediariId>>,
    { id: string; data: IntermediarioRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putIntermediazioniIntermediariId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutIntermediazioniIntermediariIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putIntermediazioniIntermediariId>>
>;
export type PutIntermediazioniIntermediariIdMutationBody = IntermediarioRequest;
export type PutIntermediazioniIntermediariIdMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Modifica Intermediario
 */
export const usePutIntermediazioniIntermediariId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putIntermediazioniIntermediariId>>,
    TError,
    { id: string; data: IntermediarioRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutIntermediazioniIntermediariIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Consente la cancellazione di un intermediario
 * @summary Elimina Intermediario
 */
export const deleteIntermediazioniIntermediariId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cfg-domande/intermediazioni/intermediari/${id}`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteIntermediazioniIntermediariIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntermediazioniIntermediariId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteIntermediazioniIntermediariId>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteIntermediazioniIntermediariId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteIntermediazioniIntermediariId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteIntermediazioniIntermediariIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteIntermediazioniIntermediariId>>
>;

export type DeleteIntermediazioniIntermediariIdMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Elimina Intermediario
 */
export const useDeleteIntermediazioniIntermediariId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteIntermediazioniIntermediariId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteIntermediazioniIntermediariIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene l'elenco delle intermediazioni filtrate in base ai parametri di ricerca
 * @summary Elenco Intermediazioni
 */
export const getIntermediazioni = (
  params?: GetIntermediazioniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListIntermediazioneDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetIntermediazioniQueryKey = (
  params?: GetIntermediazioniParams,
) =>
  [
    `/framework-cfg-domande/intermediazioni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetIntermediazioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntermediazioni>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIntermediazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getIntermediazioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntermediazioniQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntermediazioni>>
  > = ({ signal }) => getIntermediazioni(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetIntermediazioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntermediazioni>>
>;
export type GetIntermediazioniQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Intermediazioni
 */
export const useGetIntermediazioni = <
  TData = Awaited<ReturnType<typeof getIntermediazioni>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIntermediazioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIntermediazioniQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea una nuova intermediazione
 * @summary Crea Intermediazione
 */
export const postIntermediazioni = (
  intermediazioneRequest: IntermediazioneRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<IntermediazioneDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: intermediazioneRequest,
    },
    options,
  );
};

export const getPostIntermediazioniMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntermediazioni>>,
    TError,
    { data: IntermediazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntermediazioni>>,
  TError,
  { data: IntermediazioneRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntermediazioni>>,
    { data: IntermediazioneRequest }
  > = props => {
    const { data } = props ?? {};

    return postIntermediazioni(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntermediazioniMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntermediazioni>>
>;
export type PostIntermediazioniMutationBody = IntermediazioneRequest;
export type PostIntermediazioniMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea Intermediazione
 */
export const usePostIntermediazioni = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntermediazioni>>,
    TError,
    { data: IntermediazioneRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostIntermediazioniMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene l'elenco degli intermediari filtrati in base ai parametri di ricerca
 * @summary Elenco Intermediari
 */
export const getIntermediazioniIntermediari = (
  params?: GetIntermediazioniIntermediariParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListIntermediarioDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni/intermediari`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetIntermediazioniIntermediariQueryKey = (
  params?: GetIntermediazioniIntermediariParams,
) =>
  [
    `/framework-cfg-domande/intermediazioni/intermediari`,
    ...(params ? [params] : []),
  ] as const;

export const getGetIntermediazioniIntermediariQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntermediazioniIntermediari>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIntermediazioniIntermediariParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniIntermediari>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getIntermediazioniIntermediari>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntermediazioniIntermediariQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntermediazioniIntermediari>>
  > = ({ signal }) =>
    getIntermediazioniIntermediari(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetIntermediazioniIntermediariQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntermediazioniIntermediari>>
>;
export type GetIntermediazioniIntermediariQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Intermediari
 */
export const useGetIntermediazioniIntermediari = <
  TData = Awaited<ReturnType<typeof getIntermediazioniIntermediari>>,
  TError = ErrorType<unknown>,
>(
  params?: GetIntermediazioniIntermediariParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniIntermediari>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIntermediazioniIntermediariQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea un nuovo intermediario
 * @summary Crea Intermediario
 */
export const postIntermediazioniIntermediari = (
  intermediarioRequest: IntermediarioRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<IntermediarioDTO>(
    {
      url: `/framework-cfg-domande/intermediazioni/intermediari`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: intermediarioRequest,
    },
    options,
  );
};

export const getPostIntermediazioniIntermediariMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntermediazioniIntermediari>>,
    TError,
    { data: IntermediarioRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postIntermediazioniIntermediari>>,
  TError,
  { data: IntermediarioRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postIntermediazioniIntermediari>>,
    { data: IntermediarioRequest }
  > = props => {
    const { data } = props ?? {};

    return postIntermediazioniIntermediari(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostIntermediazioniIntermediariMutationResult = NonNullable<
  Awaited<ReturnType<typeof postIntermediazioniIntermediari>>
>;
export type PostIntermediazioniIntermediariMutationBody = IntermediarioRequest;
export type PostIntermediazioniIntermediariMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Crea Intermediario
 */
export const usePostIntermediazioniIntermediari = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postIntermediazioniIntermediari>>,
    TError,
    { data: IntermediarioRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostIntermediazioniIntermediariMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene l'elenco dei beneficiari delle intermediazioni
 * @summary Elenco Beneficiari
 */
export const getIntermediazioniBeneficiari = (
  params: GetIntermediazioniBeneficiariParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<IntermediazioneDTO[]>(
    {
      url: `/framework-cfg-domande/intermediazioni/beneficiari`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetIntermediazioniBeneficiariQueryKey = (
  params: GetIntermediazioniBeneficiariParams,
) =>
  [
    `/framework-cfg-domande/intermediazioni/beneficiari`,
    ...(params ? [params] : []),
  ] as const;

export const getGetIntermediazioniBeneficiariQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>,
  TError = ErrorType<unknown>,
>(
  params: GetIntermediazioniBeneficiariParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetIntermediazioniBeneficiariQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>
  > = ({ signal }) =>
    getIntermediazioniBeneficiari(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetIntermediazioniBeneficiariQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>
>;
export type GetIntermediazioniBeneficiariQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Beneficiari
 */
export const useGetIntermediazioniBeneficiari = <
  TData = Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>,
  TError = ErrorType<unknown>,
>(
  params: GetIntermediazioniBeneficiariParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getIntermediazioniBeneficiari>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetIntermediazioniBeneficiariQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
